var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "ItpBox",
        { staticClass: "mb-1", attrs: { alignItems: "center" } },
        [
          _c("ItpText", {
            staticClass: "font-weight-bold",
            attrs: {
              text: _vm.itemName,
              tooltip: _vm.itemName,
              strikethrough: _vm.isServiceStale(_vm.item)
            }
          }),
          _vm._v(" "),
          _c("ItpLink", {
            staticClass: "pl-1",
            attrs: {
              icon: _vm.$config.externalLinkIcon,
              to: { name: "app.product", params: { id: _vm.item.service.id } }
            }
          }),
          _vm._v(" "),
          _vm.item.locked
            ? _c("ItpIcon", {
                staticClass: "pl-3",
                attrs: { title: _vm._f("gettext")("Locked"), name: "fa-lock" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.invoice_group_id
            ? _c("UcProductInvoiceGroupLabel", {
                staticClass: "ml-2",
                attrs: { value: _vm.item.invoice_group_id }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("DIV", { staticClass: "ml-2" }, [
            _vm._v(
              "\n      " + _vm._s(_vm._f("date")(_vm.item.valid_from)) + " "
            ),
            _vm.item.valid_to ? _c("span", [_vm._v("-")]) : _vm._e(),
            _vm._v(
              "\n" + _vm._s(_vm._f("date")(_vm.item.valid_to)) + "\n\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpBox",
        { attrs: { direction: "column" } },
        [
          _vm.item.invoice_notes ||
          (_vm.item.transaction_notes && _vm.item.transaction_notes.length)
            ? _c(
                "ItpBox",
                { staticClass: "mb-2" },
                [
                  _c(
                    "DIV",
                    { staticClass: "mx-1" },
                    [_c("ItpIcon", { attrs: { icon: "uil:notes" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    { staticClass: "flex flex-row" },
                    [
                      _vm.item.invoice_notes
                        ? _c("ItpText", {
                            attrs: {
                              spacing: "px-1",
                              text: _vm.item.invoice_notes,
                              pre: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.transaction_notes &&
                      _vm.item.transaction_notes.length
                        ? _c("TransactionNotesDisplay", {
                            model: {
                              value: _vm.item.transaction_notes,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "transaction_notes", $$v)
                              },
                              expression: "item.transaction_notes"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.intermediated_service
            ? _c(
                "ItpBox",
                { staticClass: "mb-2" },
                [
                  _c(
                    "DIV",
                    { staticClass: "mx-1" },
                    [
                      _c("ItpIcon", {
                        attrs: { icon: "mingcute:arrows-right-fill" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ItpText", {
                    attrs: {
                      spacing: "px-1",
                      text: _vm._f("gettext")("Intermediated service")
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.billing_category
            ? _c(
                "ItpBox",
                { staticClass: "mb-2" },
                [
                  _c(
                    "DIV",
                    { staticClass: "mx-1" },
                    [
                      _c("ItpIcon", {
                        attrs: { icon: "ph:circles-three-fill" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ItpText", {
                    attrs: { spacing: "px-1", text: _vm.item.billing_category }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ItpBox",
            { staticClass: "mb-2" },
            [
              _c(
                "DIV",
                { staticClass: "mx-1" },
                [_c("ItpIcon", { attrs: { icon: "uil:cog" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpBox",
                { attrs: { "wrap-items": "" } },
                [
                  _vm.item.billing_frequency
                    ? _c("UcBillingFrequencyDisplay", {
                        staticClass: "mr-1 mb-1",
                        attrs: { value: _vm.item.billing_frequency }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.billing_date_rule
                    ? _c("UcBillingDateRuleDisplay", {
                        staticClass: "mr-1 mb-1",
                        attrs: { value: _vm.item.billing_date_rule }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.due_date_rule
                    ? _c("UcDueDateRuleDisplay", {
                        staticClass: "mr-1 mb-1",
                        attrs: { value: _vm.item.due_date_rule }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.billing_currency
                    ? _c("UcCurrencyBadge", {
                        staticClass: "mr-1 mb-1",
                        attrs: { value: _vm.item.billing_currency }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.exchange_rate_date_rule
                    ? _c("UcExchangeRateDateRuleDisplay", {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          value: _vm.item.exchange_rate_date_rule,
                          source: _vm.item.exchange_rate_source
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.description
            ? _c(
                "ItpBox",
                { staticClass: "mb-2" },
                [
                  _c(
                    "DIV",
                    { staticClass: "mx-1" },
                    [
                      _c("ItpIcon", {
                        attrs: { icon: "material-symbols:info-outline" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ItpText", {
                    attrs: {
                      spacing: "px-1",
                      text: _vm.item.description,
                      pre: ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }